import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledAvatarOption from 'components/molecules/Options/AvatarOption/AvatarOption.styles';
import utils from 'helpers/utils';
import Typography from 'components/atoms/Text/Typography/Typography';
import ActionAvatar from 'components/molecules/Avatars/ActionAvatar/ActionAvatar';

const AvatarOption = React.forwardRef((props, ref) => {
  const {
    avatar,
    label,
    reverse,
    size,
    ActionAvatarProps,
    ...innerProps
  } = useComponentProps(props, 'AvatarOption', {
    static: ['reverse']
  });

  const color = utils.string2Color(avatar);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledAvatarOption ref={ref} {...innerProps}>
    {avatar ? <ActionAvatar action={{
                              label: utils.avatarLabel(avatar),
                              tooltip: avatar
                            }}
                            color={color}
                            size="small"
                            TooltipProps={{enterDelay: 0}}
                            {...ActionAvatarProps}/> : null}
    {label ? utils.isReactElement(label) ? label : <Typography variant={size === 'smaller' ? 'body2' : 'body1'}>{label}</Typography> : null}
  </StyledAvatarOption>
});

AvatarOption.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  avatar: PropTypes.string,
  label: PropTypes.any,
  reverse: PropTypes.bool,
  size: PropTypes.string,
  ActionAvatarProps: PropTypes.object
};

export default AvatarOption;
